/* Valenore: filter op de productpagina (Alles, Bundels, Losse sets, Zelf samenstellen).
   Groepen krijgen data-vl-group; het bundelbouwer-blok (data-vl-builder) staat als aparte sectie op dezelfde pagina. */
(function () {
  var root = document.querySelector('[data-vl-filter-root]');
  if (!root) return;
  var bar = root.querySelector('[data-vl-filter-bar]');
  var buttons = Array.prototype.slice.call(bar.querySelectorAll('[data-vl-filter]'));
  var groups = Array.prototype.slice.call(root.querySelectorAll('[data-vl-group]'));
  var builder = document.querySelector('[data-vl-builder]');
  var builderWrap = builder ? (builder.closest('.shopify-section') || builder) : null;
  var buildBtn = bar.querySelector('[data-vl-filter="build"]');
  if (builder) buildBtn.hidden = false;
  var hasBundle = groups.some(function (g) { return g.dataset.vlGroup === 'bundle'; });
  var hasSingle = groups.some(function (g) { return g.dataset.vlGroup === 'single'; });
  if (!hasBundle) bar.querySelector('[data-vl-filter="bundle"]').hidden = true;
  if (!hasSingle) bar.querySelector('[data-vl-filter="single"]').hidden = true;

  var names = { all: 'all', bundles: 'bundle', bundle: 'bundle', singles: 'single', single: 'single', build: 'build' };
  var hashNames = { all: '', bundle: 'bundles', single: 'singles', build: 'build' };

  function apply(mode, updateHash) {
    buttons.forEach(function (b) {
      var on = b.dataset.vlFilter === mode;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    groups.forEach(function (g) {
      g.hidden = !(mode === 'all' || g.dataset.vlGroup === mode);
    });
    if (builderWrap) builderWrap.hidden = mode !== 'build';
    root.classList.toggle('is-build', mode === 'build');
    if (updateHash && window.history && history.replaceState) {
      history.replaceState(null, '', location.pathname + location.search + (hashNames[mode] ? '#' + hashNames[mode] : ''));
    }
  }

  buttons.forEach(function (b) {
    b.addEventListener('click', function () { apply(b.dataset.vlFilter, true); });
  });

  var start = names[(location.hash || '').replace('#', '').toLowerCase()] || 'all';
  if (start === 'build' && !builder) start = 'all';
  apply(start, false);
})();
